<template>
  <v-app-bar
    dark
    d-flex
    app
    class="navbar"
    elevation="12"
  >
    <div
      v-if="!isApproved"
      class="logo"
    >
      <img
        class="logo"
        src="/img/logo.svg"
        alt=""
      >
    </div>
    <v-app-bar-nav-icon
      v-if="isApproved"
      @click="$emit('toogleSidebar')"
    />

    <div class="status-wrapper">
      <v-switch
        v-if="!onOrderStatus"
        v-model="status"
        :false-value="0"
        :true-value="1"
        :label="statusLabel"
        color="success"
        hide-details
        :loading="loading.status"
        @change="setStatus"
      />
      <div
        v-else
        class="on-order"
        @click="$router.push(`/orders/details/${activeOrderId}`).catch(() => {})"
      >
        ON ORDER
      </div>
    </div>

    <div class="balance">
      Balance:

      <v-tooltip
        bottom
        color="#000"
      >
        <template #activator="{ on, attrs }">
          <span
            v-bind="attrs"
            class="balance-ready"
            v-on="on"
            @click="$router.push('/payouts').catch(() => {})"
          >
            ${{ user.balance_ready }}
          </span>
        </template>
        <span>Available for withdrawal</span>
      </v-tooltip>

      <v-tooltip
        bottom
        color="#000"
      >
        <template #activator="{ on, attrs }">
          <span
            class="balance-pending"
            v-bind="attrs"
            v-on="on"
          >${{ user.balance_pending }}</span>
        </template>
        <span>Pending balance</span>
      </v-tooltip>
    </div>
    <v-menu offset-y>
      <template #activator="{ on, attrs }">
        <v-btn
          text
          dark
          class="text-lowercase"
          v-bind="attrs"
          v-on="on"
        >
          <span class="text-lowercase">
            {{ user.email }}
          </span>
          <v-icon class="profile-caret">
            mdi-chevron-up
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="$router.push('/profile')">
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Navbar',

  data: () => ({
    loading: {
      status: false,
    },
    status: 0,
  }),

  computed: {
    ...mapGetters([
      'user',
      'isApproved',
      'onOrderStatus',
      'activeOrderId',
    ]),

    statusLabel() {
      return this.user.status === 0 ? 'offline' : 'online';
    },
  },

  watch: {
    // eslint-disable-next-line func-names
    'user.status': function (newVal) {
      this.status = newVal;
    },
  },

  created() {
    this.status = this.user.status;
  },

  methods: {
    logout() {
      this.$store.dispatch('logout');
    },

    async setStatus(newStatus) {
      this.loading.status = true;
      try {
        const response = await this.$store.dispatch('SET_STATUS', newStatus);
        this.loading.status = false;

        if (response.data.success) {
          this.status = newStatus;
        } else {
          this.status = newStatus === 1 ? 0 : 1;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
  },
};
</script>

<style lang="scss">

.logo {
  margin-top: 2px;
}

.status-wrapper {
  margin-left: 20px;
  background: #1f1e1e;
  border-radius: 5px;
  padding: 10px 15px;

  label {
    margin-bottom: 0;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
  }

  .on-order {
    color: #ff6000;
    font-size: 14px;
    font-weight: 900;

    &:hover {
      cursor: pointer;
    }
  }
}

.profile-caret {
  transform: rotate(180deg);
}

.v-list-item--link {
  &:hover {
    text-decoration: none;
  }
}

.balance {
  text-align: right;
  margin-right: 20px;
  flex-grow: 1;
  margin-left: auto;
}

.v-toolbar__content {
  width: 100%;
  height: 60px !important;
}

header {
  height: 60px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.balance-ready {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 3px;
  background: #509e50;
  margin-right: 5px;
  margin-left: 5px;
  color: #fff !important;
  text-decoration: none !important;

  &:hover {
    cursor: pointer;
  }
}

.balance-pending {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 3px;
  background: #424242;
  margin-right: 10px;

  &:hover {
    cursor: pointer;
  }
}
</style>
